import * as React from "react"
import { sortBy } from "lodash";
import { graphql, PageProps } from 'gatsby'
import Layout from "../../components/layout";
import createSeasonMenu from "./include/menu";
import MediaList, { MediaItemProps } from "@/components/medialist";
import createSeasonBreadcrumbs from "./include/breadcrumbs";
import SeasonSEO from "./include/seo";
import { Urls } from "@/util";

export default function view({ data }: PageProps<Queries.SeasonEpisodesPageQuery>) {
  const season = data.wwdm.season!
  
  function GetEpisodeMediaItem(episode: Queries.EpisodePropsFragment): MediaItemProps {
    return {
      intro: episode.summary ?? '',
      title: episode.title ?? '',
      url: Urls.episode(season.code, episode.index),
      subtitle: 'Aflevering ' + episode.index,
      image: episode.image,
      key: episode.index
    }
  }

  return <Layout
    title='Afleveringen'
    subtitle={`Seizoen ${season.code}`}
    image={season.image}
    breadcrumbs={createSeasonBreadcrumbs(season.code, [{ 'text':'Afleveringen', 'icon':'film', 'url':Urls.season(season.code, 'afleveringen') }])}
    tabs={createSeasonMenu(season.code, 'episodes')}
    >
      <MediaList items={sortBy(season.episodes, e => e.index).map(episode => GetEpisodeMediaItem(episode))}/>    
  </Layout>
}

export const query = graphql`    
  query SeasonEpisodesPage($id: Int!) {
    wwdm {
      season(id: $id) {
        ...SeasonMainProps
        episodes {
          ...EpisodeProps           
        }        
      }
    }
  }
  fragment EpisodeProps on WwdmGraph_Episode {
    index, title, code, summary, aired
    moneyGameEarned, moneyGameAvailable
    kdhAbs, kdhPerc, ktaPerc
    image { ...ImageData }
  }
  `;

export const Head = ({ data } : { data : Queries.SeasonIndexPageQuery}) => <SeasonSEO season={data.wwdm.season!} titlePrefix="Afleveringen in"/>